/**
 * @generated SignedSource<<5bd47a1191927ae0145b14c3c42ea5a0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable$data = {
  readonly aquaOutgoingEmailLogs: {
    readonly GetNotificationLogs: {
      readonly __typename: "QueryError";
      readonly identifier?: string | null | undefined;
      readonly logs?: {
        readonly edges: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"logsTableOfTabs_logEdges">;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
          readonly hasPreviousPage: boolean;
          readonly startCursor: string | null | undefined;
        };
      } | null | undefined;
      readonly message?: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable";
};
export type notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable$key = {
  readonly " $data"?: notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable">;
};

import aquaEmailLogsQuery_graphql from './aquaEmailLogsQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "aquaOutgoingEmailLogs",
  "GetNotificationLogs",
  "logs"
],
v1 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "kind": "RootArgument",
      "name": "notificationActionType"
    },
    {
      "kind": "RootArgument",
      "name": "notificationType"
    },
    {
      "kind": "RootArgument",
      "name": "projectId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": aquaEmailLogsQuery_graphql
    }
  },
  "name": "notificationTable_spaAppsServicedeskNotificationLogs_NotificationLogsTable",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "concreteType": "AquaOutgoingEmailLogsQueryApi",
      "kind": "LinkedField",
      "name": "aquaOutgoingEmailLogs",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "notificationActionType",
              "variableName": "notificationActionType"
            },
            {
              "kind": "Variable",
              "name": "notificationType",
              "variableName": "notificationType"
            },
            {
              "kind": "Variable",
              "name": "projectId",
              "variableName": "projectId"
            }
          ],
          "kind": "LinkedField",
          "name": "GetNotificationLogs",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": "logs",
                  "concreteType": "AquaOutgoingEmailLogConnection",
                  "kind": "LinkedField",
                  "name": "__aquaOutgoingEmail__logs_connection",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "AquaOutgoingEmailLogItemEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "logsTableOfTabs_logEdges"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "cursor"
                        },
                        {
                          "concreteType": "AquaOutgoingEmailLogItem",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v1/*: any*/)
                          ]
                        }
                      ]
                    },
                    {
                      "concreteType": "PageInfo",
                      "kind": "LinkedField",
                      "name": "pageInfo",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "startCursor"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "endCursor"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "hasNextPage"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "hasPreviousPage"
                        }
                      ]
                    }
                  ]
                }
              ],
              "type": "AquaOutgoingEmailLog"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "identifier"
                },
                {
                  "kind": "ScalarField",
                  "name": "message"
                }
              ],
              "type": "QueryError"
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "ce3f76d0fe1ca275bccfadfeb21cb8d7";

export default node;
